import React from 'react';
import clsx from 'clsx';

import { TextField } from 'components/text-field/text-field';

import SearchIcon from 'public/assets/icons/search.svg';

import styles from './search.module.scss';

export interface ISearchProps {
	searchValue: string;
	searchPlaceholderText: string;
	small?: boolean;
	handleSearchOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	high?: boolean;
	hideIcon?: boolean;
}

export const Search = (props: ISearchProps): React.JSX.Element => (
	<div className={clsx(styles.search, props.small ? styles.small : '', props.high ? styles.high : '')}>
		<TextField
			placeholder={props.searchPlaceholderText}
			onChange={props.handleSearchOnChange}
			type="text"
			value={props.searchValue}
			icon={props.hideIcon ? undefined : <SearchIcon />}
			iconPosition="right"
		/>
	</div>
);
